import type { MouseEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import classNames from 'classnames';
import LoadingSpinner from '@/shared/components/LoadingSpinner';
import DownloadIcon from '@/shared/icons/flip-ui-kit/small/Download';

export const ExportCsvButton = ({
  label = 'Export CSV',
  onExport,
  canExport,
}: {
  label?: string;
  onExport: () => void | Promise<void>;
  canExport: boolean;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (_: MouseEvent) => onExport(),
  });

  return (
    <button
      type="button"
      className={classNames(
        'flex min-w-[80px] shrink-0 items-center gap-x-1 whitespace-nowrap font-aeonikMedium text-12 text-cf-light-3 enabled:hover:text-cf-white disabled:text-cf-light-1',
      )}
      disabled={!canExport || isPending}
      onClick={mutate}
    >
      {isPending ? (
        <LoadingSpinner className="!h-[16px] !w-[16px]" />
      ) : (
        <>
          <DownloadIcon className={canExport ? 'text-cf-green-2' : 'text-cf-light-1'} />
          <span>{label}</span>
        </>
      )}
    </button>
  );
};
